import { Box } from '@mui/material';

import Divider from '../../../../../../common/divider/divider';

import Events from '../events';
import OperationMetadata from '../operation-metadata';
import { Operation } from '../operation-metadata/interfaces';

interface Props {
  operation: Operation;
}

const OperationDetails = ({ operation }: Props) => {
  const { events } = operation;

  return (
    <Box flexDirection="column" display="flex" justifyContent="space-between">
      <OperationMetadata detailsType="session" operation={operation} />
      <Divider />
      <Box sx={{ height: '100%' }}>
        <Events events={events} />
      </Box>
    </Box>
  );
};

export default OperationDetails;
